import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SeverityDistribution',
  props: {
    severity: null,
    narrowBreakpoint: { default: 890 },
    donutSize: { default: 44 }
  },
  setup(__props: any) {

const props = __props as { severity: { high: number; medium: number; low: number }, narrowBreakpoint: number, donutSize: number };



const total = computed(() => props.severity.high + props.severity.medium + props.severity.low);

function pct(value: number) {
  if (total.value === 0) return 0;
  return (value / total.value) * 100;
}

const donutStrokeWidth = computed(() => Math.max(2, Math.round(props.donutSize / 12)));
const donutRadius = computed(() => (props.donutSize - donutStrokeWidth.value) / 2 - 2);
const donutCircum = computed(() => 2 * Math.PI * donutRadius.value);

const arcs = computed(() => {
  if (total.value === 0) {
    return {
      high: { len: 0, offset: 0 },
      medium: { len: 0, offset: 0 },
      low: { len: 0, offset: 0 },
    };
  }
  const circ = donutCircum.value;
  const high = (props.severity.high / total.value) * circ;
  const medium = (props.severity.medium / total.value) * circ;
  const low = (props.severity.low / total.value) * circ;
  return {
    high: { len: high, offset: 0 },
    medium: { len: medium, offset: -high },
    low: { len: low, offset: -(high + medium) },
  };
});

const title = computed(
  () =>
    `High: ${props.severity.high}, Medium: ${props.severity.medium}, Low: ${props.severity.low}`
);

const center = computed(() => props.donutSize / 2);

return { __sfc: true,props, total, pct, donutStrokeWidth, donutRadius, donutCircum, arcs, title, center }
}

})